globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Websites = appCustomerSpace.Controllers.Websites || {};

appCustomerSpace.Controllers.Websites.BlogArticlesController = (function(superClass) {
    utils.extend(BlogArticlesController, superClass);

    function BlogArticlesController() {
        return BlogArticlesController.__super__.constructor.apply(this, arguments);
    }

    $.extend(BlogArticlesController.prototype, {
      init: function() {
        this.$html = $('html');

        if(this.$html.find('.article-edit-form').length) {
          this.initEvents();
        }

        if(this.$html.find('.social-media-share-buttons-container').length) {
          ShareEvents.initEvents(this.$html);
        }

        return BlogArticlesController.__super__.init.apply(this, arguments);
      },

      initEvents: function() {
        var $textarea = this.$html.find('textarea');

        $textarea.each(function() {
          var $currentTextarea = $(this);
          var textareaId = $currentTextarea.attr('id');
          var existingEditor = CKEDITOR.instances[textareaId];

          if (existingEditor) {
            existingEditor.destroy();
          }

          CKEDITOR.replace(textareaId, {
            customConfig: globalThis.ckeditor_assets.configBlogArticle,
            wordcount: {
              showParagraphs: false,
              showWordCount: true,
              showCharCount: false,
              countSpacesAsChars: true
            }
          });
        });
      }
    });

    return BlogArticlesController;

})(appCustomerSpace.Controllers.Websites.MainController);
